// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2Lkz1","name":"ConsentHeader_name__3uUx6","birthday":"ConsentHeader_birthday__20XGx","skeleton":"ConsentHeader_skeleton__1CZyv"};